<template>
  <div class="autocomplete-wrapper">
    <input
      ref="input"
      :value="query"
      :placeholder="placeholder"
      :class="inputClass"
      autocomplete="off"
      @input="onInput($event.target.value)"
      @keydown.down.prevent="onArrowDown"
      @keydown.up.prevent="onArrowUp"
      @keydown.enter.prevent="onEnter"
      @keydown.esc="onEscape"
      @focus="onFocus"
      @blur="onBlur"
    >
    <div
      v-if="isOpen && items.length > 0"
      class="tt-menu"
      style="display: block;"
    >
      <div class="tt-dataset tt-dataset-items">
        <div
          v-for="(item, index) in items"
          ref="suggestions"
          :key="index"
          :class="['tt-suggestion', 'tt-selectable', { 'tt-is-under-cursor': index === highlightedIndex }]"
          @mousedown.prevent="selectItem(item)"
          @mouseover="highlightedIndex = index"
        >
          <div v-html="highlightMatch(getDisplay(item))"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AutocompleteInput',
  props: {
    query: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      default: function () { return [] }
    },
    placeholder: {
      type: String,
      default: ''
    },
    displayFn: {
      type: Function,
      default: null
    },
    inputClass: {
      type: [String, Array, Object],
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      isOpen: false,
      highlightedIndex: -1,
      awaitingResults: false
    }
  },
  watch: {
    items: function () {
      this.highlightedIndex = -1
      if (this.awaitingResults && this.items.length > 0) {
        this.isOpen = true
      }
    }
  },
  mounted: function () {
    var self = this
    document.addEventListener('click', function (e) {
      if (!self.$el.contains(e.target)) {
        self.isOpen = false
      }
    })
  },
  methods: {
    getDisplay: function (item) {
      if (this.displayFn) {
        return this.displayFn(item)
      }
      return String(item)
    },
    onInput: function (value) {
      this.awaitingResults = true
      this.$emit('update:query', value)
      this.$emit('input-changed', value)
      this.isOpen = true
    },
    onArrowDown: function () {
      if (this.highlightedIndex < this.items.length - 1) {
        this.highlightedIndex++
        this.scrollToHighlighted()
      }
    },
    onArrowUp: function () {
      if (this.highlightedIndex > 0) {
        this.highlightedIndex--
        this.scrollToHighlighted()
      }
    },
    onEnter: function () {
      if (this.highlightedIndex >= 0 && this.highlightedIndex < this.items.length) {
        this.selectItem(this.items[this.highlightedIndex])
      }
    },
    onEscape: function () {
      this.isOpen = false
    },
    onFocus: function () {
      if (this.items.length > 0 && this.query.length > 0) {
        this.isOpen = true
      }
    },
    onBlur: function () {
      // Small delay to allow mousedown on suggestions to fire
      var self = this
      setTimeout(function () {
        self.isOpen = false
      }, 150)
    },
    selectItem: function (item) {
      this.isOpen = false
      this.highlightedIndex = -1
      this.awaitingResults = false
      this.$emit('item-selected', item)
    },
    scrollToHighlighted: function () {
      var self = this
      this.$nextTick(function () {
        if (self.$refs.suggestions && self.$refs.suggestions[self.highlightedIndex]) {
          self.$refs.suggestions[self.highlightedIndex].scrollIntoView({ block: 'nearest' })
        }
      })
    },
    highlightMatch: function (text) {
      if (!this.query || this.query.length === 0) {
        return this.escapeHtml(text)
      }
      var safeText = this.escapeHtml(text)
      var escaped = this.query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
      var safeQuery = this.escapeHtml(escaped)
      var regex = new RegExp('(' + safeQuery + ')', 'gi')
      return safeText.replace(regex, '<strong>$1</strong>')
    },
    escapeHtml: function (str) {
      var div = document.createElement('div')
      div.appendChild(document.createTextNode(str))
      return div.innerHTML
    }
  }
}
</script>

<style lang="scss">
.autocomplete-wrapper {
  position: relative;

  .tt-menu {
    position: absolute;
    top: 100%;
    left: 0;
  }
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/find-my-photos/components/AutocompleteInput.vue